export default function Future2Logo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 48" role="img" aria-label="Future 2">
      <text
        x="0"
        y="34"
        fill="currentColor"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="28"
        fontWeight="700"
        letterSpacing="-0.5"
      >
        Future 2
      </text>
    </svg>
  );
}
